
export default {

    nav: require('../img/nav.png'),
    share: require('../img/share.png'),

    // list
    located: require('../img/located.png'),
    tel: require('../img/tel.png'),

    // index
    swiper_load: require('../img/index/swiper_load.jpg'),
    hot_top_load: require('../img/index/hot_top_load.jpg'),
    navBack: require('../img/nav-back.png'),
    navShare: require('../img/nav-share.png'),
    navCenter: require('../img/nav-center.png'),
    arrow_bottom: require('../img/arrow_bottom.png'),
    to_top: require('../img/to_top.png'),
    loading: require('../img/loading.png'),
    wifi_out: require('../img/wifi_out.png'),
    again: require('../img/again.png'),
    wantSee: require('../img/want_see.png'),
    preSale: require('../img/pre_sale.png'),
    been: require('../img/been.png'),
    movie_bg: require('../img/movie_bg.png'),
    right_arrow: require('../img/right_arrow.png'),
    go_buy: require('../img/go_buy.png'),
    discount: require('../img/discount.png'),
    search: require('../img/search.png'),
    loading_animation: require('../img/loading-animation.gif'),

    //  movie_schedule
    nextDay: require('../img/next_day.png'),
    reload: require('../img/reload.png'),
    no_cinema: require('../img/movie-schedule/no_cinema.png'),
    see_tomorrow: require('../img/movie-schedule/see_tomorrow.png'),

    // search
    blockSearch: require('../img/block_search.png'),
    avatar: require('../img/avatar.png'),
    group1: require('../img/movie_red.png'),
    movie1: require('../img/m-movie.png'),
    group2: require('../img/m-piao.png'),
    close: require('../img/close.png'),

    // nav
    movie: require('../img/movie.png'),
    movie_red: require('../img/movie_red.png'),
    piao: require('../img/piao.png'),
    piao_red: require('../img/piao_red.png'),
    around: require('../img/around.png'),
    around_red: require('../img/around_red.png'),
    my: require('../img/my.png'),
    my_red: require('../img/my_red.png'),


    gift: require('../img/gift.png'),
    gift_red: require('../img/gift_red.png'),



    // order
    off: require('../img/order/off.png'),
    on: require('../img/order/on.png'),
    o_right: require('../img/order/right.png'),
    o_top: require('../img/order/top.png'),
    o_right_g: require('../img/order/right_g.png'),
    border: require('../img/order/border.png'),
    time: require('../img/order/time.png'),
    right: require('../img/order/right.png'),
    greenRight: require('../img/icon-green-arrow.png'),

    // nomore
    no_more: require('../img/no-more/no-more.png'),
    no_list: require('../img/no-more/no-list.png'),

    // error
    error_icon: require('../img/error.png'),

    use: require('../img/user.png')

};
